import { createContext, useContext, useEffect } from 'react';
import { seoContent } from './content/seo';

const LanguageContext = createContext({ lang: 'fr', withPath: (path) => path });

export function LanguageProvider({ lang, children }) {
    const withPath = (path) => {
        if (lang !== 'es') return path;
        return path === '/' ? '/es' : `/es${path}`;
    };

    useEffect(() => {
        document.documentElement.lang = lang;
        const seo = seoContent[lang];
        document.title = seo.title;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) metaDescription.setAttribute('content', seo.description);
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, withPath }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}

// Maps the current pathname to its equivalent under another language's URL tree.
export function getAltLangPath(pathname, targetLang) {
    const isEs = pathname.startsWith('/es');
    const rest = isEs ? (pathname.slice(3) || '/') : pathname;
    if (targetLang === 'es') {
        return rest === '/' ? '/es' : `/es${rest}`;
    }
    return rest;
}
